import { useState, useEffect, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

export function useImageUpload(type = 'product') {
  const [imageFile, setImageFile] = useState(null);
  const [localImageUrl, setLocalImageUrl] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const uploadImage = useCallback(async (file, customFileName) => {
    if (!file) return null;
    setIsUploading(true);
    
    try {
      const token = await getAccessTokenSilently();
      const fileName = customFileName || file.name;
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_DOMAIN}/api/s3/signed-url?type=${type}&fileName=${encodeURIComponent(fileName)}`, 
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      const { data: { signedUrl } } = response;
      
      if (signedUrl) {
        const result = await axios.put(signedUrl, file, {
          headers: { 'Content-Type': file.type }
        });
        
        if (result.status === 200) {
          const url = signedUrl.split("?")[0];
          setImageUrl(url);
          return url;
        }
      }
      return null;
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    } finally {
      setIsUploading(false);
    }
  }, [getAccessTokenSilently, type]);
  
  useEffect(() => {
    if (imageFile) {
      uploadImage(imageFile);
    }
  }, [imageFile, uploadImage]);
  
  const reset = useCallback(() => {
    setImageFile(null);
    setLocalImageUrl(null);
    setImageUrl(null);
  }, []);

  return {
    imageFile,
    setImageFile,
    localImageUrl,
    setLocalImageUrl,
    imageUrl,
    setImageUrl,
    isUploading,
    uploadImage,
    reset
  };
}